import { Action, TableActions, readPermissions } from "../../../features/roles";
import { TableName } from '../../../tables'

export const warehousePermissions = (): TableActions[] => readPermissions().concat([
    { tableName: TableName.DELIVERY_ORDERS, actions: [Action.SAVE, Action.REMOVE] },
    { tableName: TableName.DELIVERIES2, actions: [Action.SAVE, Action.REMOVE] },
    { tableName: TableName.EMPLOYEES, actions: [Action.SAVE, Action.REMOVE] },
    { tableName: TableName.PURCHASE_ORDERS, actions: [Action.SAVE] },
    { tableName: TableName.SALE_ORDERS, actions: [Action.SAVE] },
    { tableName: TableName.STOCK, actions: [Action.SAVE] }
])
